(() => {
  function initialize(section) {
    if (section.dataset.ugcReady === 'true') return;
    section.dataset.ugcReady = 'true';

    const track = section.querySelector('[data-ugc-track]');
    const cards = Array.from(section.querySelectorAll('[data-ugc-card]'));
    const previous = section.querySelector('[data-ugc-prev]');
    const next = section.querySelector('[data-ugc-next]');
    if (!track || !cards.length) return;

    const stopOtherVideos = (activeVideo) => {
      cards.forEach((card) => {
        const video = card.querySelector('[data-ugc-video]');
        if (video !== activeVideo && !video.paused) video.pause();
      });
    };

    cards.forEach((card) => {
      const video = card.querySelector('[data-ugc-video]');
      const play = card.querySelector('[data-ugc-play]');
      const sound = card.querySelector('[data-ugc-sound]');
      if (!video || !play || !sound) return;

      video.defaultMuted = false;
      video.muted = false;
      card.classList.remove('is-muted');

      const startVideo = () => {
        stopOtherVideos(video);
        if (!video.dataset.loaded) {
          const source = video.querySelector('source[data-src]');
          if (source) {
            source.src = source.dataset.src;
            video.load();
          }
          video.dataset.loaded = 'true';
        }
        video.play().catch(() => {});
      };

      const toggleVideo = () => video.paused ? startVideo() : video.pause();

      play.addEventListener('click', toggleVideo);
      video.addEventListener('click', toggleVideo);
      video.addEventListener('play', () => card.classList.add('is-playing'));
      video.addEventListener('pause', () => card.classList.remove('is-playing'));
      video.addEventListener('ended', () => card.classList.remove('is-playing'));

      sound.addEventListener('click', () => {
        video.muted = !video.muted;
        card.classList.toggle('is-muted', video.muted);
        sound.setAttribute('aria-label', video.muted ? 'Sesi aç' : 'Sesi kapat');
      });
    });

    const updateArrows = () => {
      if (!previous || !next) return;
      previous.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };

    const scrollOneCard = (direction) => {
      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    };

    previous?.addEventListener('click', () => scrollOneCard(-1));
    next?.addEventListener('click', () => scrollOneCard(1));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    requestAnimationFrame(updateArrows);
  }

  function initializeAll(root = document) {
    root.querySelectorAll('[data-dorimo-ugc]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
